export const pathway = {
  finalize: 'Finalize',
  finalizeTitle: 'Finalization',
  prevStep: 'Previous step',
  nextStep: 'Next step',
  stageProgress: 'Step {current} of {total}',
  saving: 'Saving…',
  summaryTitle: 'Your configuration',
  summaryCount: 'Selected: {count}',
  mail: 'Email address',
  configure: 'Configure',
  configureView: 'Configuration template view',
  createNew: 'Create new',
  finalizeDescription:
    'A link to the finalized configuration template will be sent to the provided email address',
  finalizeRulesAccept: 'I accept the terms',
  finalizeRules: 'of service',
  mailRequired: 'Email is required',
  rulesRequired: 'Acceptance of the terms of service is required',
  summary: 'Summary',
  summaryButton: 'Preview',
  print: 'Print',
  pendingChangesMessage:
    'One of your selections causes a conflict with others. Resolve them before continuing.',
  pendingChangesDetails:
    'You can also revert the options causing the conflicts.',
  details: 'Details',
  conflictOnSubmit: 'You cannot submit the configuration due to conflicts.',
  packageConflictOnAccept:
    'Package acceptance introduced conflicts. Resolve conflicts to continue.',
  notFoundDraft: 'Not found configuration template with given id',
  loadingEditor: 'Loading configuration template...',
  loadingProperties: 'Loading configuration template properties...',
  loadingModels: 'Downloading models...',
  simulationTitle: 'Pathway simulation for configuration template: {config}',
  simulationPublishTitle: 'Publishing configuration template: {config}',
  simulationRefresh: 'Refresh',
  simulationRefreshTooltip: 'Refresh data in simulation',
  simulationRulesRefresh: 'Refresh rules',
  simulationRulesRefreshTooltip: 'Apply new rules without reloading models',
  simulationExistingTitle: 'Active simulation found',
  simulationExistingDescription:
    'You can continue the existing simulation or start a new one (it will overwrite the previous simulation).',
  simulationContinueExisting: 'Continue existing',
  simulationCreateNew: 'Start new',
  simulationStartedNew: 'A new simulation has been created.',
  simulationOutdatedConflict:
    'This simulation was based on an older configuration version and has been removed. Creating a new simulation.',
  violation: 'Violation',
  simulationModels: 'Models loaded in simulation',
  simulationModel: 'Model',
  simulationModelsTime: 'Loading time',
  simulationModelsSize: 'File size',
  noSimulationModels: 'No models were loaded',
  swaps: {
    noChanges: 'No changes',
    title:
      'Your last change forced changes in other configuration template elements',
    noAutomaticChanges:
      'Your latest selections did not cause any automatic changes',
    optionAdded: 'A new option has been added:',
    optionRemoved: 'An option has been removed:',
    optionReplaced: 'Option',
    optionReplacedTo: 'has been replaced with',
  },
  toolbox: {
    previewChanges: 'Preview changes',
    previewChangesTooltip: 'See changes that were made automatically',
    packages: 'Packages',
    packagesNoNew: 'Packages (no new items to accept)',
    packagesAvailableTitle: 'Packages available for acceptance',
    packagesAvailableDescription:
      'Select packages you want to accept based on active triggers.',
    pendingPackagesPreview: 'Pending packages:',
    packageConflictsTitle: 'Conflicts after package acceptance:',
    packageConflictsBlockingInfo:
      'You cannot continue until conflicts are resolved.',
    noPackagesToAccept: 'No packages available for acceptance.',
    acceptPackage: 'Accept',
    usedPackage: 'Used',
    usedPackageChangeWarning:
      '*Changing any option from a used package will remove that package.',
    camera: 'Camera',
    fullscreen: 'Fullscreen',
    rotate: 'Rotate',
    resetCamera: 'Reset camera',
    scenery: 'Scenery',
    background: 'Background',
    goBackCamera: 'Previous camera',
  },
  localStorage: {
    info: 'Would you like to continue an existing configuration template?',
    edited: 'Edited',
    created: 'Created',
    replace: 'Apply',
    delete: 'Delete',
  },
  conflicts: {
    dialogTitle: 'Configuration conflict details',
    dialogSubtitle: 'Detected {count} conflict | Detected {count} conflicts',
    noConflicts: 'No conflicts to display',
    violationType: 'Violation type: {type}',
    traceDetails: 'Trace details:',
    priority: 'Priority: {priority}',
  },
  controls: {
    notSupportedType: 'Unsupported control type: {type}',
    noAvailableOption: 'Configuration error (no available option)',
  },
}
